import * as React from "react";

export const IconCloseModal = (_props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.35938 0.721191L17.3594 16.7212" stroke="white" strokeWidth="2"/>
    <path d="M17.3594 0.721191L0.692711 16.7212" stroke="white" strokeWidth="2"/>
  </svg>
);
